import React from "react";

const PdfBoletaIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9717 8.35915C26.9906 9.37324 26.9906 11.0211 25.9717 11.9085L22.4057 15.4577L12.4717 5.57042L16.0377 2.02113C17.0566 1.00704 18.7123 1.00704 19.6038 2.02113L21.8962 4.30282L25.717 0.5L27.5 2.27465L23.6792 6.07746L25.9717 8.35915ZM18.5849 15.7113L16.8019 13.9366L13.2358 17.4859L10.5613 14.8239L14.1274 11.2746L12.3443 9.5L8.7783 13.0493L6.86792 11.2746L3.30189 14.8239C2.28302 15.838 2.28302 17.4859 3.30189 18.3732L5.59434 20.6549L0.5 25.7254L2.28302 27.5L7.37736 22.4296L9.66981 24.7113C10.6887 25.7254 12.3443 25.7254 13.2358 24.7113L16.8019 21.162L15.0189 19.3873L18.5849 15.7113Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default PdfBoletaIcon;
